import { render, staticRenderFns } from "./Allergies.vue?vue&type=template&id=5b27aa9c&scoped=true&"
import script from "./Allergies.vue?vue&type=script&lang=js&"
export * from "./Allergies.vue?vue&type=script&lang=js&"
import style0 from "./Allergies.vue?vue&type=style&index=0&id=5b27aa9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27aa9c",
  null
  
)

export default component.exports